// External modules
import React from 'react';
import { isEmpty, cloneDeep } from 'lodash';
import * as moment from 'moment';
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete';
import { connect } from 'react-redux';


import acHTTPClient from 'services/ACHTTPClient';

import FileCopyIcon from '@material-ui/icons/FileCopyRounded';
import LinkIcon from '@material-ui/icons/Link';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import ACUIElement from '../../atoms/ACUIElement';
import 'react-toastify/dist/ReactToastify.css';
// Internal modules
import {
  getCountryCode,
  getPaymentStatusStyle,
  getActivityStatusStyle,
  getBookingItemPaymentStatuses,
  getBookingItemActivityStatuses,
  getMediaForUIName,
  getUIElementType,
  getUIElement,
  getCurrencies,
  getCurrencyStyle,
} from '../../common/global';
import { getDefaultWhens } from '../../common/providers';
import ACDateTimeRange from '../../atoms/ACDateTimeRange';
import ACButton from '../../atoms/ACButton';
import ACStatus from '../../atoms/ACStatus';
import ACMedia from '../../atoms/ACMedia';
import ACDropDown from '../../atoms/ACDropDown';
import ACRoundBoxWithDotLayout from '../../atoms/ACRoundBoxWithDotLayout';
import { withStyles } from '@material-ui/core/styles';
import config from '../../../config/config';

import styles from './ProviderDetails.module.scss';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

export const MySwitch = withStyles({
  switchBase: {
    color: "gray",
    '&$checked': {
      color: "#FFE916",
    },
    '&$checked + $track': {
      backgroundColor: "#FFE916",
    },
  },
  checked: {},
  track: {},
})(Switch);

const authClientId = config.authClientId;
const authClientURLBase = config.authClientURLBase;
const authClientConnection = config.authClientConnection;
const providersHQURL = config.providersHQURL;

const endingKeys = ['type'];
const endingCallOutKeys = ['type', 'subType']

class ProviderDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showEnding: false,
    };

    this.onChangeText = this.onChangeText.bind(this);
    this.onChangeAddress = this.onChangeAddress.bind(this);
    this.onSelectAddress = this.onSelectAddress.bind(this);
    this.onChangeTime = this.onChangeTime.bind(this);
    this.onCreateLogin = this.onCreateLogin.bind(this);
    this.onChangeNotes = this.onChangeNotes.bind(this);
    this.onChangeItemDefaultPaymentStatus = this.onChangeItemDefaultPaymentStatus.bind(this);
    this.onChangeItemDefaultActivityStatus = this.onChangeItemDefaultActivityStatus.bind(this);
    this.setShowEnding = this.setShowEnding.bind(this);
    this.onChangeStoryboardToggle = this.onChangeStoryboardToggle.bind(this);

  }

  setShowEnding(provider){
    const { uiElements } = provider;
    const ending = getUIElement(uiElements, getUIElementType().ending);

    const endingCallOut = getUIElement(
      uiElements,
      getUIElementType().ending,
      getUIElementType().callOut
    );
    const endingKeysArr = Object.keys(ending).filter(field => !endingKeys.includes(field)).filter((ele) => ending[ele]);
    const endingCallOutKeysArr = Object.keys(endingCallOut).filter(field => !endingCallOutKeys.includes(field)).filter((ele) => endingCallOut[ele]);
    const shouldShowEndingCallout = endingKeysArr.length > 0 || endingCallOutKeysArr.length > 0;
    this.setState({showEnding: shouldShowEndingCallout})
  }

  componentDidMount(){
    const provider = this.props.provider;
    this.setShowEnding(provider);
  }

  componentDidUpdate(prevProps) {
    const { media = {} } = this.props;
    if (!isEmpty(media) && media !== prevProps.media) {
      this.updateMedia(media);
    }
    const provider = this.props.provider;
    if(prevProps?.provider !== provider){
      this.setShowEnding(provider);
    }
    const prevpois = prevProps?.provider?.POIs;
    const newPois = provider?.POIs
    if(prevpois && newPois && (prevpois[prevpois?.length-1]?.id !== newPois[newPois?.length-1]?.id)){
      this.onConfirmationFunction();
    }
  }


  updateMedia(media) {
    const { provider = {} } = cloneDeep(this.props);
    const { name, url } = media;
    let uiElement = {};
    let uiEleMedia = {};
    switch (name) {
      case 'callOut':
        uiElement = getUIElement(provider.uiElements, getUIElementType().callOut);
        break;
      case 'endingCallOut':
        uiElement = getUIElement(
          provider.uiElements,
          getUIElementType().ending,
          getUIElementType().callOut
        );
        break;
      case 'ending':
        uiElement = getUIElement(provider.uiElements, getUIElementType().ending);
        break;
      case 'providerMedia':
        const providerMedia = provider.media || { type: 'image', url: '' };
        providerMedia.url = media.url;
        this.props.onUpdateProviderFunc('media', providerMedia);
        break;
      default:
        break;
    }
    if (isEmpty(uiElement)) return;

    uiEleMedia = uiElement.media || {};
    uiEleMedia.url = url;
    uiElement.media = uiEleMedia;
    this.updateProviderUIElementData(cloneDeep(uiElement));
  }

  onChangeText(key, event) {
    let value = event.target.value;
    this.props.onUpdateProviderFunc(key, value);
  }

  onChangeBusinessId = (e) => {
    const { value } = e.target;

    let { businessId } = this.props.provider;
    if (isEmpty(businessId)) businessId = { id: '', name: 'ABN' };
    businessId.id = value;

    this.props.onUpdateProviderFunc('businessId', businessId);
  };

  onChangeBankingDetails = (e) => {
    const { name, value } = e.target;

    let { bank } = this.props.provider;
    if (isEmpty(bank)) bank = { accountName: '' };
    bank[name] = value;

    this.props.onUpdateProviderFunc('bank', bank);
  };

  getPaymentStatuses() {
    const statuses = getBookingItemPaymentStatuses();
    let providerStatuses = statuses.filter((status) => status.showOnProvider);
    return providerStatuses;
  }

  getCurrencyOptions() {
    const currencies = getCurrencies();
    return currencies;
  }

  getActivityStauses() {
    const statuses = getBookingItemActivityStatuses();
    let providerStatuses = statuses.filter((status) => status.showOnProvider);
    return providerStatuses;
  }

  onChangePhoneNumber(event) {
    let { phone, where } = this.props.provider;
    if (!phone) phone = {};

    let value = event.target.value;
    if (!value) {
      phone = {};
      this.props.onUpdateProviderFunc('phone', phone);
    }

    var numbers = value.match(/\d+/g);
    if (numbers) {
      let joinedNumbers = numbers.join('');
      if (joinedNumbers.length > 1 && joinedNumbers.indexOf('0') === 0) {
        joinedNumbers = joinedNumbers.substring(1, joinedNumbers.length);
      }
      phone.number = joinedNumbers;
      if (where || where.country) phone.countryCode = getCountryCode(where.country);
      this.props.onUpdateProviderFunc('phone', phone);
    }
  }

  onChangeEmailAdddress(event) {
    let { email } = this.props.provider;
    if (!email) email = {};

    let value = event.target.value;
    email.address = value;
    this.props.onUpdateProviderFunc('email', email);
  }

  async savePoiBefore(POIs){
      await this.props.onSavePOIsFunc(POIs)
      return true
  }

  async updatePovider(id){
    await this.props.getProviderFunc(id)
    return true
}



  async onChangeStoryboardToggle(event){
    let { enablingStoryboard } = this.props.provider;
    if(!enablingStoryboard) enablingStoryboard = false;
    // let value = event.target.checked;
    if(enablingStoryboard===true){
      window.alert("You can't disable the storyboard mode")
    }
    else{
      const confirm = window.confirm("Note, you won't be able to disable the storyboard mode and unsaved changes will be lost. Please confirm to continue.")
      if(confirm){
        const provider =this.props.provider;
        localStorage.setItem('enableStoryboard',true)
        if( provider?.POIs?.length>0 && !provider?.POIs[provider?.POIs?.length -1]?.id){
          const providerPois = provider?.POIs || []
           this.savePoiBefore(providerPois);  
        }
        else{
           this.onConfirmationFunction();
        }
      }

    }
    
  }

  async onConfirmationFunction(){
    const provider =this.props.provider;
    let { enablingStoryboard } = this.props.provider;
    if(!enablingStoryboard) enablingStoryboard = false;
    const enableStoryBoardStatus = localStorage.getItem("enableStoryboard");
    let status = false
    if(enableStoryBoardStatus === 'true'){
      status = true
    }
    if(!enablingStoryboard && status){
       localStorage.removeItem("enableStoryboard");
       await this.props.onUpdateProviderStoryboard(provider?.id,true);
       const updatedProvider =  this.props.finalprovider;
       const finalPois =[]
       if(!isEmpty(updatedProvider?.POIs)){
        updatedProvider.POIs.forEach((poi)=>{
           if(poi.category){
             let obj = {
               category:poi.category,
               id:poi.id
             }
             finalPois.push(obj)
           }else{
            let obj = {
              category:'Unsorted',
              id:poi.id
            }
            finalPois.push(obj)
           }
         })
       }

       const bio = provider?.notes ? provider?.notes.find((note)=>note.type === 'bio') : {type:'bio',
         text:provider?.note?.public};
         const storyboard ={
         bio:bio?.text || '',
         media:provider.media,
         medias:provider.medias,
         name:"Legacy" ,
         pois:finalPois ||[],
         providerId:provider.id,
         status: "active",
         uiElements:provider.uiElements,
       }
       await this.props.onSaveStoryboardFunc(storyboard);
      }
  }

  onChangeAddress(address) {
    let where = {
      address,
    };

    this.props.onUpdateProviderAddressFunc(where);
  }

  onSelectAddress(address) {
    geocodeByAddress(address)
      .then((results) => {
        console.log('results', results);
        if (results && results[0]) {
          let r = results[0];

          let where = {};

          if (!r.address_components) return;
          const acs = r.address_components;

          const country = acs.find((ac) => {
            return ac.types.includes('country');
          });
          country && country.long_name ? (where.country = country.long_name) : (where.country = '');

          const state = acs.find((ac) => {
            return ac.types.includes('administrative_area_level_1');
          });
          state && state.long_name ? (where.state = state.long_name) : (where.state = '');

          const city = acs.find((ac) => {
            return ac.types.includes('locality');
          });
          city && city.long_name ? (where.city = city.long_name) : (where.city = '');
          where.address = r.formatted_address || '';

          let { phone } = this.props.provider;
          if (!phone) phone = {};

          if (where || where.country) phone.countryCode = getCountryCode(where.country);

          this.props.onUpdateProviderFunc('phone', phone);
          this.props.onUpdateProviderAddressFunc(where);
        }
      })
      .catch((error) => console.error('Error', error));
  }

  onChangeTime(day, fromOrTo, value) {
    let valueStr = '';

    if (moment.isMoment(value)) valueStr = value.format('HH:mm');
    let ws = [];
    if (this.props.provider && this.props.provider.whens) ws = [...this.props.provider.whens];

    const exists = ws.some((w) => w.value === day);
    if (exists) {
      ws.map((when) => {
        if (when.value === day) {
          when[fromOrTo] = valueStr;
        }
        return when;
      });
    } else {
      const newWhen = {
        key: 'day',
        value: day,
        [fromOrTo]: valueStr,
      };
      ws.push(newWhen);
    }

    this.props.onUpdateProviderFunc('whens', ws);
  }

  onCreateLogin(user) {
    // TODO: Move somewhere
    if (user.email || user.email.address) return;
    var url = `${authClientURLBase}/dbconnections/signup`;
    var data = {
      client_id: authClientId,
      email: user.email.address,
      username: user.username,
      password: user.password,
      connection: authClientConnection,
      user_metadata: {
        providerId: user.id,
        name: user.name,
      },
      app_metadata: {
        role: 'Provider',
      },
    };

    const config = { url: url, method: 'POST', data };
    acHTTPClient
      .request(config)
      .then((response) => {
        console.log('response', response);
        alert('Login Created');
      })
      .catch((error) => {
        console.error('error', error);
        alert(error);
      });
  }

  onChangeNotes(type, event) {
    let text = event.target.value;

    let provider = this.props.provider;
    if (!provider) return;

    const note = provider.note || {};
    switch (type) {
      case 'bio':
        note.public = text;
        break;
      case 'internal':
        note.private = text;
        break;
      case 'provider':
        note.provider = text;
        break;
      case 'internalAdditional':
        note.internalAdditional = text;
        break;
      default:
        break;
    }

    this.props.onUpdateProviderFunc('note', note);
  }

  onChangeItemDefaultPaymentStatus(event) {
    const { value = '' } = event.target;

    const itemPaymentStatuses = this.getPaymentStatuses();
    let { settings = {} } = this.props.provider;

    const payment =
      itemPaymentStatuses.find((pStatus) => {
        return pStatus.name === value;
      }) || {};

    settings.itemPaymentStatus = payment.value;
    this.props.onUpdateProviderFunc('settings', settings);
  }

  onChangeCurrency(event) {
    const { value = '' } = event.target;

    const currencyOptions = this.getCurrencyOptions();
    let { settings = {} } = this.props.provider;

    const currency =
      currencyOptions.find((curr) => {
        return curr.name === value;
      }) || {};

    settings.currency = currency.value;
    this.props.onUpdateProviderFunc('settings', settings);
  }

  onUploadCallOutMedia(file) {
    // TODO: Implement me
  }

  onChangeItemDefaultActivityStatus(event) {
    const { value = '' } = event.target;
    const itemActivityStatuses = this.getActivityStauses();
    let { settings = {} } = this.props.provider;

    const activity =
      itemActivityStatuses.find((activityStatus) => {
        return activityStatus.name === value;
      }) || {};

    settings.itemActivityStatus = activity.value;
    this.props.onUpdateProviderFunc('settings', settings);
  }

  onUploadProviderMedia = (e) => {
    if (!e.target) return null;
    const { files = [] } = e.target;

    const mediaFor = {
      ui: getMediaForUIName().provider,
      name: 'providerMedia',
      s3FolderName: 'generic',
    };
    const { provider = {}, uploadMediaFunc } = this.props;
    const { media } = provider;
    uploadMediaFunc(mediaFor, media.type || '', files[0] || {});
  };

  onUploadACUIElementMedia = (name, s3FolderName, mediaType, file) => {
    const mediaFor = { ui: getMediaForUIName().provider, name: name, s3FolderName: s3FolderName };

    this.props.uploadMediaFunc(mediaFor, mediaType, file);
  };

  updateProviderUIElementData(uiElement) {
    const { provider = {} } = cloneDeep(this.props);
    let { uiElements = [] } = provider;
    const { type = '', subType = '' } = uiElement;
    uiElements = uiElements ? uiElements : [];
    const index = uiElements.findIndex((ele) => {
      if (!isEmpty(subType)) {
        return ele.type === type && ele.subType === subType;
      } else return ele.type === type && isEmpty(ele.subType);
    });
    if (index >= 0) uiElements[index] = uiElement;
    else uiElements.push(uiElement);
    this.props.onUpdateProviderFunc('uiElements', uiElements);
  }

  onChangeACUIElement = (uiElement) => {
    this.updateProviderUIElementData(uiElement);
  };

  //All values should be text fields. BSB & Account are not 'numbers', so they can have multiple leading zeros.
  renderBankAccountDetails(bank) {
    const { bsb = '', accountNumber = '', accountName = '' } = bank || {};
    return (
      <div className={styles.bankingDetails}>
        <TextField
          id="simple-start-adornment"
          name="bsb"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                BSB / Routing
              </InputAdornment>
            ),
          }}
          value={bsb}
          type="text"
          className={styles.textField}
          onChange={this.onChangeBankingDetails}
        />
        <TextField
          id="simple-start-adornment"
          name="accountNumber"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                Account Number
              </InputAdornment>
            ),
          }}
          value={accountNumber}
          type="text"
          className={styles.textField}
          onChange={this.onChangeBankingDetails}
        />
        <TextField
          id="simple-start-adornment"
          name="accountName"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                Account Name
              </InputAdornment>
            ),
          }}
          value={accountName}
          className={styles.textField}
          onChange={this.onChangeBankingDetails}
        />
      </div>
    );
  }

  renderCallOut() {
    const mediaFor = 'generic';
    const { provider = {} } = cloneDeep(this.props);
    const { uiElements } = provider;
    const callOut = getUIElement(uiElements, getUIElementType().callOut);
    const { media = {} } = callOut;
    if (isEmpty(media.type)) media.type = 'image';
    callOut.media = media;
    return (
      <div className={styles.section}>
        <div className={styles.sectionHeading}>Call Out</div>
        <ACUIElement
          name="callOut"
          mediaFor={mediaFor}
          uiElement={callOut}
          onChangeACUIElementFunc={this.onChangeACUIElement}
          onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
          isMediaTypeDisabled={true}
        />
      </div>
    );
  }

  renderEnding(provider) {
    // TODO: Change mediaFor to more appropriate folder name

    const mediaFor = 'generic';
    const { uiElements } = provider;
    const ending = getUIElement(uiElements, getUIElementType().ending);

    const endingCallOut = getUIElement(
      uiElements,
      getUIElementType().ending,
      getUIElementType().callOut
    );

    return (
      <div className={styles.bottom}>
        <div className={styles.row}>
          <p className={styles.font}>Ending</p>
        {!this.state.showEnding &&<ACButton
              text={'Add Ending'}
              icon={<AddCircleOutlineIcon />}
              onClickFunc={() => this.setState({showEnding: true})}
            />}
          </div>
        {this.state.showEnding &&
        <>
        <ACUIElement
          name="ending"
          mediaFor={mediaFor}
          uiElement={ending}
          showMedia={true}
          onChangeACUIElementFunc={this.onChangeACUIElement}
          onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
        />
        <div className={styles.sectionSubHeading}>Call Out</div>
        <ACUIElement
          name="endingCallOut"
          mediaFor={mediaFor}
          uiElement={endingCallOut}
          showBody={false}
          onChangeACUIElementFunc={this.onChangeACUIElement}
          onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
        />
        </>
        }
      </div>
    );
  }

  renderOpenTime(when) {
    let from = null;
    if (when.from && when.from !== undefined) from = moment(when.from, 'HH:mm');
    let to = null;
    if (when.to && when.to !== undefined) to = moment(when.to, 'HH:mm');

    return (
      <div className={styles.openTime}>
        <span className={styles.day}>{when.value}</span>
        <ACDateTimeRange
          day={when.value}
          from={from}
          to={to}
          type="KeyboardTimePicker"
          ampm={true}
          onChangeTimeFunc={this.onChangeTime}
          format="hh:mm a"
          classNameFromIcon={styles.timeRangeIcon}
          classNameToIcon={styles.timeRangeIcon}
        />
      </div>
    );
  }

  renderOpenTimes(whens) {
    let tempWhens = whens || [];
    let ws = [];

    getDefaultWhens().forEach((defaultWhen) => {
      let tempWhen = {
        ...defaultWhen,
      };

      let w = tempWhens.find((w) => {
        return w.value === defaultWhen.value;
      });

      if (w) {
        tempWhen.from = w.from;
        tempWhen.to = w.to;
      }

      ws.push(this.renderOpenTime(tempWhen));
    });

    if (isEmpty(ws)) return;

    return <div>{ws}</div>;
  }

  renderDefaultCurrency(currency) {
    let options = [];

    const currencyOptions = this.getCurrencyOptions();

    const currencyStyle = getCurrencyStyle(currency);


    if(currencyOptions) {
      Object.values(currencyOptions).forEach((curr) => {
        options.push(curr.name);
      });
    }

     const currencyOptionValue =
      currencyOptions.find((curr) => {
        return curr.value === currency;
      }) || {};

    options.unshift('Select Currency');
    return (
      <ACRoundBoxWithDotLayout layoutStyle={currencyStyle}>
        <ACDropDown
          text={currencyOptionValue.name}
          isEditable={true}
          options={options}
          selected={currencyOptionValue.name || 'Select Currency'}
          onChangeFunc={(e) => this.onChangeCurrency(e)}
          backgroundColor="transparent"
          isMultiple={false}
          color={currencyStyle.color}
        />
      </ACRoundBoxWithDotLayout>
    );
  }

  renderItemPaymentStatus(paymentStatus) {
    let options = [];

    const itemPaymentStatuses = this.getPaymentStatuses();
    if (itemPaymentStatuses) {
      Object.values(itemPaymentStatuses).forEach((pStatus) => {
        options.push(pStatus.name);
      });
    }

    const paymentStatusValue =
      itemPaymentStatuses.find((pStatus) => {
        return pStatus.value === paymentStatus;
      }) || {};

    const paymentStatusStyle = getPaymentStatusStyle(paymentStatus);
    let showDot = false;

    if (paymentStatusStyle.dotColor && !isEmpty(paymentStatusStyle.dotColor)) showDot = true;

    return (
      <ACRoundBoxWithDotLayout
        layoutStyle={paymentStatusStyle}
        classNameOuter={styles.paymentStatusSelect}
        showDot={showDot}
      >
        <ACDropDown
          text={paymentStatusValue.name || ''}
          isEditable={true}
          options={options}
          selected={paymentStatusValue.name || ''}
          onChangeFunc={(e) => this.onChangeItemDefaultPaymentStatus(e)}
          backgroundColor="transparent"
          color={paymentStatusStyle.color}
          isMultiple={false}
        />
      </ACRoundBoxWithDotLayout>
    );
  }

  renderItemActivityStatus(activityStatus) {
    let options = [];

    const itemActivityStatuses = this.getActivityStauses();
    if (itemActivityStatuses) {
      Object.values(itemActivityStatuses).forEach((aStatus) => {
        options.push(aStatus.name);
      });
    }

    const activityStatusValue =
      itemActivityStatuses.find((aStatus) => {
        return aStatus.value === activityStatus;
      }) || {};

    const activityStatusStyle = getActivityStatusStyle(activityStatus);
    let showDot = false;

    if (activityStatusStyle.dotColor && !isEmpty(activityStatusStyle.dotColor)) showDot = true;

    return (
      <ACRoundBoxWithDotLayout
        layoutStyle={activityStatusStyle}
        classNameOuter={styles.activityStatusSelect}
        showDot={showDot}
      >
        <ACDropDown
          text={activityStatusValue.name || ''}
          isEditable={true}
          options={options}
          selected={activityStatusValue.name || ''}
          onChangeFunc={(e) => this.onChangeItemDefaultActivityStatus(e)}
          backgroundColor="transparent"
          color={activityStatusStyle.color}
          isMultiple={false}
        />
      </ACRoundBoxWithDotLayout>
    );
  }

  renderDetails(provider) {
    // New note
    const { note = {}, businessId = {}, bank = {} } = provider;

    const _businessId = businessId.id || '';
    ;

    let itemPaymentStatus;
    if (provider.settings && !isEmpty(provider.settings)) {
      itemPaymentStatus = provider.settings.itemPaymentStatus || '';
    }

    let currency;
    if(provider.settings && !isEmpty(provider.settings)) {
      currency = provider.settings.currency || '';
    }

    let itemActivityStatus;
    if (provider.settings && !isEmpty(provider.settings)) {
      itemActivityStatus = provider.settings.itemActivityStatus || '';
    }

    const id = provider.id || '';
    const contact = provider.contact || '';
    const enablingStoryboard = provider.enablingStoryboard || false;
    const email = provider.email || {};
    const emailAddress = email.address || '';
    const phone = provider.phone || {};
    const phoneNumber = phone.number || '';
    const countryCode = phone.countryCode || '';
    
    const where = provider.where || {};
    const address = where.address || '';
    const city = where.city || '';
    const state = where.state || '';
    const country = where.country || '';

    const notes = provider.notes || [];
    const media = provider.media || {};

    const bio =
      notes.find((n) => {
        return n.type === 'bio';
      }) || {};
    const bioText = note.public || bio.text || '';
    const internal =
      notes.find((n) => {
        return n.type === 'internal';
      }) || {};
    const internalText = note.private || internal.text || '';
    const equipmentText = note.provider || '';
    const internalAdditionalText = note.internalAdditional || '';
    const providersHQLink = `${providersHQURL}/providers/${id}`;
    return (
      <div>
        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
          <TextField
            id="simple-start-adornment"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" className={styles.adornment}>
                  Provider ID
                </InputAdornment>
              ),
            }}
            value={id}
            className={styles.textField}
            disabled
          />
          { id && <div style={{ position: 'relative', display: 'flex', justifyContent:'space-between', width: '100%'}}>
            <p style={{ width: '200px',fontSize:'12px',color:'#61666c',marginLeft: '10px'}}>
            Enable StoryBoarding
            </p>         
                <MySwitch
                checked={enablingStoryboard}
                onChange={(event)=>{
                  this.onChangeStoryboardToggle(event)
                }}
                color="primary"
                name="checkedB"
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
          </div>}
          <a href={providersHQLink} target="_blank" rel="noopener noreferrer">
            <LinkIcon
              style={{ position: 'absolute', right: 0, top: 6, width: 30, height: 30 }}
              title="View in Provider UI"
              titleAccess="View in Provider UI"
            />
          </a>
        </div>
        <TextField
          id="simple-start-adornment"
          name="businessId"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                ABN
              </InputAdornment>
            ),
          }}
          value={_businessId}
          className={styles.textField}
          onChange={this.onChangeBusinessId}
        />
        {this.renderBankAccountDetails(bank)}
        <TextField
          id="simple-start-adornment"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                Contact
              </InputAdornment>
            ),
          }}
          value={contact}
          className={styles.textField}
          onChange={(e) => this.onChangeText('contact', e)}
        />
        <TextField
          id="simple-start-adornment"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                Email
              </InputAdornment>
            ),
          }}
          value={emailAddress}
          className={styles.textField}
          onChange={(e) => this.onChangeEmailAdddress(e)}
        />
        <PlacesAutocomplete
          value={address}
          onChange={this.onChangeAddress}
          onSelect={this.onSelectAddress}
        >
          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
            <div className={styles.placesAutoComplete}>
              <div className={styles.placesAutoCompleteMain}>
                <span>Address</span>
                <input
                  {...getInputProps({
                    placeholder: 'Address, Suburb, State, Country',
                  })}
                />
              </div>
              <div className={styles.placesAutoCompleteSelect}>
                {loading && <div>Loading...</div>}
                {suggestions.map((suggestion) => {
                  const className = suggestion.active
                    ? styles.suggestionItemActive
                    : styles.suggestionItem;
                  return (
                    <div
                      {...getSuggestionItemProps(suggestion, {
                        className,
                      })}
                    >
                      <span>{suggestion.description}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </PlacesAutocomplete>
        <TextField
          id="simple-start-adornment"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                Phone
              </InputAdornment>
            ),
          }}
          value={phoneNumber}
          className={styles.textField}
          onChange={(e) => this.onChangePhoneNumber(e)}
        />
        <TextField
          id="simple-start-adornment"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                City
              </InputAdornment>
            ),
          }}
          value={city}
          className={styles.textField}
          disabled
        />
        <TextField
          id="simple-start-adornment"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                State
              </InputAdornment>
            ),
          }}
          value={state}
          className={styles.textField}
          disabled
        />
        <TextField
          id="simple-start-adornment"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                Country
              </InputAdornment>
            ),
          }}
          value={country}
          className={styles.textField}
          disabled
        />
        <TextField
          id="simple-start-adornment"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                Country Code
              </InputAdornment>
            ),
          }}
          value={countryCode}
          className={styles.textField}
          disabled
        />
         <div className={styles.defaultCurrency}>
          <div
            style={{
              display: 'flex',
            }}
          >
            <span>Default Currency</span>
            {this.renderDefaultCurrency(currency)}
          </div>
        </div>
        <div className={styles.paymentDefaultStatus}>
          <div
            style={{
              display: 'flex',
            }}
          >
            <span>Default Payment Method</span>
            {this.renderItemPaymentStatus(itemPaymentStatus)}
          </div>
        </div>
        <div className={styles.activityDefaultStatus}>
          <div
            style={{
              display: 'flex',
            }}
          >
            <span>Default Booking Method</span>
            {this.renderItemActivityStatus(itemActivityStatus)}
          </div>
        </div>
        {
          enablingStoryboard? '' :
          <ACMedia
          name="providerMedia"
          media={media}
          accept="image/*"
          onUploadMediaFunc={this.onUploadProviderMedia}
          isMediaTypeDisabled={true}
        />
        }
       
        <div className={styles.openTimes}>
          <span className={styles.title}>Open Times</span>
          {this.renderOpenTimes(provider.whens)}
        </div>
        <div
          style={{
            color: 'black',
            margin: '20px auto',
          }}
        >
          Notes
        </div>
        {enablingStoryboard?'':
        <>
        Bio
        <TextField
          value={bioText}
          className={styles.note}
          onChange={(e) => this.onChangeNotes('bio', e)}
          placeholder="Short bio about the provider. This will appear in clue set."
          multiline
          rows="15"
        />
        </>
        }
        
        Equipment
        <TextField
          value={equipmentText}
          className={styles.note}
          onChange={(e) => this.onChangeNotes('provider', e)}
          placeholder="Some additional info...."
          multiline
          rows="4"
        />
        Planner notes
        <TextField
          value={internalText}
          className={styles.note}
          onChange={(e) => this.onChangeNotes('internal', e)}
          placeholder="Eg, if John isn't there ask for Claire."
          multiline
          rows="4"
        />
        Additional internal notes
        <TextField
          value={internalAdditionalText}
          className={styles.note}
          onChange={(e) => this.onChangeNotes('internalAdditional', e)}
          placeholder="Some additional internal info...."
          multiline
          rows="15"
        />
        {enablingStoryboard?'':this.renderCallOut()}
      </div>
    );
  }

  render() {
    const provider = this.props.provider;

    if (isEmpty(provider)) return <div />;

    const { name = '' } = provider;

    return (
      <div className={styles.root}>
        <div className={styles.top}>
          <div className={styles.header}>
            Details
          </div>
          <div>
            <div className={styles.name}>
              <TextField
                value={name}
                className={styles.nameText}
                onChange={(e) => this.onChangeText('name', e)}
                placeholder="Provider Name"
              />
            </div>
            <ACStatus
              type="provider"
              status={provider.status}
              isEditable={true}
              onChangeFunc={(e) => this.onChangeText('status', e)}
            />
          </div>
        </div>
        <div className={styles.bottom}>
          {this.renderDetails(provider)}
          
          {provider.enablingStoryboard ?'':
          <>
          <div className={styles.separator}/>
          {this.renderEnding(provider)}
          </>}
          <div style={{display:'flex',justifyContent:"center",alignItems:'center'}}>
        </div>
        </div>
        <div style={{marginTop:"20px",marginBottom:"20px",display:"flex",alignItems:"center",justifyContent:"center"}}>
        <ACButton
          text={'Clone'}
          icon={<FileCopyIcon />}
          onClickFunc={() => this.props.onCopyProviderFunc(provider)}
        />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const stateProviders = state.providers;
  let finalprovider;

  if (stateProviders) {
    if (stateProviders.provider) {
      finalprovider = stateProviders.provider.data;
    }
  }

  return {
    finalprovider
  };
};

export default connect(mapStateToProps)(ProviderDetails);
